import Api from "../apiService";

class CalculatorPresetsApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/calculator_presets`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/calculator_presets/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/calculator_presets`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/calculator_presets/${id}`,
      data,
      Api.authHeaders()
    );
  }

  preview(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/calculator_presets/preview`,
      data,
      Api.authHeaders()
    );
  }

  destroy(companyId, id) {
    return Api.deleteRequest(
      `companies/${companyId}/calculator_presets/${id}`,
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/calculator_presets/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/calculator_presets/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }

  resetToDefault(companyId, id) {
    return Api.postRequest(
      `companies/${companyId}/calculator_presets/${id}/reset_to_default`,
      {},
      Api.authHeaders()
    );
  }

  setPrimary(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/calculator_presets/${id}/set_primary`,
      {},
      Api.authHeaders()
    );
  }

  sources(companyId) {
    return Api.getRequest(
      `companies/${companyId}/operational/calculator_preset_sources`,
      {},
      Api.authHeaders()
    );
  }

  operations(companyId) {
    return Api.getRequest(
      `companies/${companyId}/operational/calculator_preset_operations`,
      {},
      Api.authHeaders()
    );
  }

  // Учебное определение и preview-значения принадлежат backend-конфигурации.
  example(companyId) {
    return Api.getRequest(
      `companies/${companyId}/operational/calculator_preset_example`,
      {},
      Api.authHeaders()
    );
  }
}

export default new CalculatorPresetsApi();
